import React, { createContext, useContext, useState, useEffect } from 'react';

// 创建应用上下文
const AppContext = createContext();

// 自定义钩子，方便使用上下文
export const useAppContext = () => {
  return useContext(AppContext);
};

// 应用提供者组件
export const AppProvider = ({ children }) => {


  var _appName = "HAND PRO";
  const hostname = window.location.hostname;
  if (hostname.includes('fupan.72plus.pro')) {
    _appName = '复盘 PRO';
  } else if (process.env.NODE_ENV === 'development') {
    _appName = 'HAND PRO';
  } else {
    _appName = 'HAND PRO';
  }

  const [appName, setAppName] = useState(_appName);

  useEffect(() => {
    setAppName(_appName);
  }, []);

  return (
    <AppContext.Provider value={{ appName }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext; 